<!--
* @Name：付款任务明细页面
* @Author: LiHao
* @Date: 2025-06-25
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>产品名称：</span>
        <span>{{ item.itemName }}</span>
      </van-row>
      <van-row>
        <span>规格型号：</span>
        <span>{{ item.standard }}</span>
      </van-row>
      <van-row>
        <span>合同金额(元)：</span>
        <span>{{ item.productAmount }}</span>
      </van-row>
      <van-row>
        <span>税率(%)：</span>
        <span>{{ item.taxRate }}</span>
      </van-row>
      <van-row>
        <span>已验收金额(元)：</span>
        <span>{{ item.acceptedAmount }}</span>
      </van-row>
      <van-row>
        <span>已付款金额(元)：</span>
        <span>{{ item.payedAmount }}</span>
      </van-row>
      <van-row>
        <span>本次付款金额(元)：</span>
        <span>{{ item.payAmount }}</span>
      </van-row>
      <van-row>
        <span>备注：</span>
        <span>{{ item.remark }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'TaskDetails',
  data() {
    return {}
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  methods: {}
}
</script>
